export default __webpack_public_path__ + "static/media/Letters3_11.e277fa97.png";